import { useEffect } from 'react';
import FJImageEnhancerLeftContainer from './FJImageEnhancerLeft/FJImageEnhancerLeftContainer';
import FJImageEnhancerRightContainer from './FJImageEnhancerRight/FJImageEnhancerRightContainer';
import { useDispatch } from 'react-redux';
import FJActionImageEnhancer from '../../redux/action/FJActionImageEnhancer';

const FJImageEnhancer = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        //初始化
        dispatch(FJActionImageEnhancer.loadImageEnhancerPageAction());
    }, [dispatch]);

    return (
        <>
            <FJImageEnhancerLeftContainer />
            <FJImageEnhancerRightContainer />
        </>
    );
};

export default FJImageEnhancer;
